/**
 * Les numeros de la maison, ecrits une seule fois.
 *
 * Le pied de page affichait « +224 621 16 43 73 » et appelait
 * `tel:+22462116433` : le lien avait ete tape a part, un chiffre de moins.
 * Les trois numeros etaient dans ce cas. Un client qui touchait « appeler »
 * sur son telephone tombait sur un numero qui n'existe pas, et rien a
 * l'ecran ne le laissait deviner.
 *
 * Le lien est maintenant derive du texte affiche : les deux ne peuvent plus
 * diverger. Le numero WhatsApp, lui, etait recopie en dur dans la fiche
 * produit et dans les commandes ; il vit ici aussi.
 */
export const TELEPHONES = [
  '+224 621 16 43 73',
  '+224 621 96 74 16',
  '+224 614 16 45 77',
]

export const WHATSAPP = '+224 621 96 74 16'

// Meme domaine que le site : l'ancienne adresse en .gn n'a jamais existe.
export const EMAIL = 'contact@abbusinessgn.com'

const chiffres = (numero) => numero.replace(/\D/g, '')

export const lienTel = (numero) => `tel:+${chiffres(numero)}`

export const lienWhatsApp = (message) =>
  `https://wa.me/${chiffres(WHATSAPP)}${message ? `?text=${encodeURIComponent(message)}` : ''}`
